// data-fields.js

// cannot use CSS vars here
export const getFieldStyle = (isEditable, isOrigDiff, isNewDiff, isDirty, showDiffs) => {
    let style = 'background-color: #E9E5EA; ';                          // default - readonly gray

    if (isEditable) style = 'background-color: #FFFFFF; ';
    if (!showDiffs) return style;

    if (isOrigDiff) style += 'text-decoration: line-through; ';         // append
    if (!isEditable) return style;                                      // left side

    if (isNewDiff || isDirty) style = 'background-color: #EAC8F6; ';    // replace - light purple
    return style;
}

